"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReactionUpdatedEventName = exports.ReactionCreatedEventName = exports.SwitchedByAdminEventName = exports.StoryEventName = exports.FeedEventName = void 0;
exports.FeedEventName = 'feed';
exports.StoryEventName = 'story';
exports.SwitchedByAdminEventName = 'switched';
exports.ReactionCreatedEventName = 'reaction-created';
exports.ReactionUpdatedEventName = 'reaction-updated';
//# sourceMappingURL=feed.js.map